import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { SendStatus } from 'src/app/core/api/models';

@Directive({
  selector: '[sendStatusStyle]',
  standalone: true,
})
export class SendStatusDirective implements OnInit {
  @Input('sendStatusStyle') sendStatus: SendStatus;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.sendStatusStyle();
  }

  sendStatusStyle() {
    //danger
    if (
      [
        SendStatus.ErrorInSending,
        SendStatus.ErrorInGetItc,
        SendStatus.BlackList,
      ].includes(this.sendStatus)
    )
      return 'text-danger font-weight-500';
    // success
    else if ([SendStatus.Sent].includes(this.sendStatus))
      return 'text-success font-weight-500';
    // stored
    else if ([SendStatus.Stored].includes(this.sendStatus))
      return 'text-primary font-weight-500';
    else return '';
  }
}
